export const ASCNAME = 'ascname';
export const DESCNAME = 'descname';
export const ASCATTACK = 'ascattack';
export const DESCATTACK = 'descattack';
export const ALL = 'all';
